import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/assets/login/google-logo-9808_bx.png'
import _imports_1 from '../../../public/assets/login/google-logo-9808_bx@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-13a35451"),n=n(),_popScopeId(),n)
const _hoisted_1 = _imports_0 + ' 1x, ' + _imports_1 + ' 2x'
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"position":"absolute","left":"0"},
  alt: "login-with-google",
  id: "google-logo-9808_bx",
  src: _imports_0,
  srcset: _hoisted_1
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "google-login-text" }, "Sign in with Google", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createBlock(_component_ion_button, {
    color: "white",
    expand: "block",
    onClick: $setup.signIn,
    style: {"min-height":"55px"},
    id: "login-via-google"
  }, {
    default: _withCtx(() => [
      _hoisted_2,
      _hoisted_3
    ]),
    _: 1
  }, 8, ["onClick"]))
}